/**
 * Focuses an element on mount
 * @example <input :v-focus="true" />
 * @example <input v-focus />
 */
const focus = {
  mounted: (el, binding) => {
    if (binding.value === undefined || binding.value) {
      el.focus();
    }
  }
};

export default focus;
